import { Component, OnInit, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule } from '@angular/common';
import { ModalComponent } from "../modal/modal.component";
import { InicioService } from '../../services/inicio.service';
import { EvaluacionEtService } from '../../services/evaluacion-et.service';
import { CalculoCuotaComponent } from "./calculo-cuota/calculo-cuota.component";

@Component({
  selector: 'app-evaluacion-et',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule, CalculoCuotaComponent],
  templateUrl: './evaluacion-et.component.html',
  styleUrl: './evaluacion-et.component.css'
})
export class EvaluacionEtComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;
  sel_edo!: number;
  estado: any = [];
  resultado: any = [];
  filteredResultado: any[] = []; // Nuevo array para los resultados filtrados
  errorMessage: string = '';
  searchTerm: string = ''; // Variable para almacenar el término de búsqueda
  isCalculoCuota: boolean = false;
  id_organizacion: number = 0;
  nombre_organizacion: string = '';
  identificacion: string = '';
  id_estado: number = 0;

  private srvLogin = inject(InicioService);
  private servicios = inject(EvaluacionEtService);

  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.listarOrganizaciones('1').subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.estado = rs.data['estado'];
        this.sel_edo = 1;
        this.resultado = rs.data['empresas'];
        console.log('prueba:   ',rs.data)
        this.filteredResultado = [...this.resultado]; // Actualiza los resultados filtrados al cambiar el año
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  consulta_combos(){
    let estado = (document.getElementById('estado') as HTMLInputElement);
    this.mdl.cargando();
    this.servicios.listarOrganizaciones(estado.value).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.estado = rs.data['estado'];
        this.sel_edo = parseInt(estado.value);
        this.resultado = rs.data['empresas'];
        console.log('prueba222222:   ',rs.data)
        this.filteredResultado = [...this.resultado]; // Actualiza los resultados filtrados al cambiar el año
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  // Método para filtrar la tabla
  buscar() {
    this.filteredResultado = this.resultado.filter((item: any) => {
      const identificacion = item.identificacion ? this.quitarAcentos(item.identificacion.toLowerCase()) : '';
      const nombre = item.nombre ? this.quitarAcentos(item.nombre.toLowerCase()) : '';
      const estado = item.estado ? this.quitarAcentos(item.estado.toLowerCase()) : '';
      const term = this.searchTerm.toLowerCase();
      return (
        identificacion.includes(term) ||
        nombre.includes(term) ||
        estado.includes(term)
      );
    });
  }
  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  enviar(id_organizacion: number, identificacion: string, nombre: string, id_estado: number){
    this.id_organizacion = id_organizacion;
    this.nombre_organizacion = nombre;
    this.identificacion = identificacion;
    this.isCalculoCuota = true;
  }

  volver(rsl: any) {
    this.isCalculoCuota = rsl.value;
    if(rsl.validador){
      this.titulo = '!EXITO¡';
      this.tipo_color = 'success';
      this.letra_color = 'light';
      this.mensaje = 'La petición fue realizada con exito.';
      this.mdl.alerta();
      this.mdl.cargando();
      this.servicios.listarOrganizaciones('1').subscribe({
        next: (rs) => {
          this.mdl.cerrar();
          (document.getElementById('buscar') as HTMLInputElement).value = '';
          this.estado = rs.data['estado'];
          this.sel_edo = parseInt('1');
          this.resultado = rs.data['empresas'];
          this.filteredResultado = [...this.resultado]; // Actualiza los resultados filtrados al cambiar el año
        },
        error: (error) => {
          this.errorMessage = error.message; // Muestra el mensaje de error al usuario
          //console.error("Error en el componente:", error); // Registro del error en el componente
        }
      });
    }
  }





}
